import { api } from "@/lib/api";

let cache = null;
let pending = null;

export const getSettings = () => {
  if (cache) return Promise.resolve(cache);
  if (pending) return pending;
  pending = api
    .get("/settings")
    .then(({ data }) => {
      cache = data;
      pending = null;
      return data;
    })
    .catch(() => {
      pending = null;
      return { logo_url: "" };
    });
  return pending;
};

export const refreshSettings = async () => {
  cache = null;
  return getSettings();
};
